import React from "react";
import { useTranslation } from "@helpers/translate";
import { useDispatch } from "react-redux";
import { toggleSignUpModal } from "@actions/authModalsActions";
import CardButton from "../buttons/CardButton";
import ArrowRightIcon from "@components/library/Icons/ArrowRightIcon";
import person1 from "@assets/img/1-person.jpg";
import person2 from "@assets/img/2-person.jpg";
import person3 from "@assets/img/3-person.jpg";
import person4 from "@assets/img/4-person.jpg";
import "./Hero.sass";

const Avatar = ({ src, alt }) => (
  <img className="hero__avatar" src={src} alt={alt} />
);

const Hero = () => {
  const { __ } = useTranslation();
  const dispatch = useDispatch();

  const handleTryDemo = () => {
    dispatch(toggleSignUpModal(true));
  };

  return (
    <section id="company" className="hero padding-container">
      <div className="hero__content">
        <h1 className="hero__title">
          <span className="hero__title-gradient">{__("main.hero.title1")}</span>
        </h1>
        <p className="hero__subtitle text-shark">
          {__("main.hero.subtitle1")}{" "}
          <span className="text-spun-pearl">{__("main.hero.subtitle2")}</span>{" "}
          {__("main.hero.subtitle3")}
        </p>
      </div>

      <div className="hero__stats">
        <div className="hero__stats-header">
          <span className="hero__stats-number">100K+</span>
          <div className="hero__avatars">
            <Avatar src={person1} alt="User 1" />
            <Avatar src={person2} alt="User 2" />
            <Avatar src={person3} alt="User 3" />
            <Avatar src={person4} alt="User 4" />
          </div>
        </div>

        <p className="hero__description text-storm-gray">
          {__("main.hero.description")}
        </p>

        <a href="#testimonials" className="hero__link">
          <span className="hero__link-text text-shark">
            {__("main.hero.learnMore")}
          </span>
          <ArrowRightIcon className="hero__link-icon" />
        </a>
      </div>
      <CardButton
        variant="primary"
        className="hero__button"
        onClick={handleTryDemo}
        icon={
          <svg
            width="8"
            height="8"
            viewBox="0 0 8 8"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M0.353516 7.5L7.35352 0.5M0.353516 0.5H7.35352V7.5"
              stroke="white"
            />
          </svg>
        }
      >
        {__("main.hero.tryFreeDemo")}
      </CardButton>
    </section>
  );
};

export default Hero;
